(function () {

    var STEP = 176;

    function init(wrapper) {
        var track   = wrapper.querySelector('.destacados-carousel-track');
        var cards   = Array.from(track.querySelectorAll('.destacado-card'));
        if (!cards.length) return;

        var current = 0;

        // Clonar botones para limpiar listeners previos
        function replaceBtn(sel) {
            var old   = wrapper.querySelector(sel);
            var clone = old.cloneNode(true);
            old.parentNode.replaceChild(clone, old);
            return clone;
        }
        var prevBtn = replaceBtn('.destacados-arrow--prev');
        var nextBtn = replaceBtn('.destacados-arrow--next');

        function setActive(idx) {
            current = idx;
            cards.forEach(function (c, i) {
                c.classList.toggle('is-active', i === idx);
            });
        }

        function goTo(idx) {
            if (idx < 0 || idx >= cards.length) return;
            track.scrollTo({ left: idx * STEP, behavior: 'smooth' });
            setActive(idx);
        }

        prevBtn.addEventListener('click', function () { goTo(current - 1); });
        nextBtn.addEventListener('click', function () { goTo(current + 1); });

        // Sincronizar tras swipe manual
        var t;
        track.addEventListener('scroll', function () {
            clearTimeout(t);
            t = setTimeout(function () {
                var idx = Math.round(track.scrollLeft / STEP);
                idx = Math.max(0, Math.min(idx, cards.length - 1));
                if (idx !== current) setActive(idx);
            }, 120);
        });

        // Estado inicial
        track.scrollLeft = 0;
        setActive(0);
    }

    // Auto-init cuando el partial llega por AJAX
    function tryInit(root) {
        var wrapper = root && root.querySelector
            ? root.querySelector('.destacados-carousel-wrapper')
            : null;
        if (wrapper && !wrapper.dataset.ready) {
            wrapper.dataset.ready = '1';
            init(wrapper);
        }
    }

    new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) tryInit(node);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

    // Por si ya está en el DOM al cargar el script
    tryInit(document);

}());
